<template>
	<div id="activitie-applying">
		<van-cell-group>
			<van-field v-model="name" input-align="right" label="申请人" placeholder="请输入名称" maxlength="15" />
			<van-field
				v-model="phone"
				type="tel"
				input-align="right"
				label="联系电话"
				placeholder="请输入联系电话"
				:error-message="phoneErrorMessage"
				@blur="isValidPhone"
				maxlength="11"
				error-message-align="right"
			/>
			<van-field v-model="company" input-align="right" label="公司名称" placeholder="请输入公司名称" maxlength="30" />
		</van-cell-group>

		<van-cell-group id="activitie-container">
			<van-field v-model="theme" input-align="right" label="活动主题" placeholder="（可输入50字）" maxlength="50" />
			<van-field v-model="date" @click="showDate = true" placeholder="请选择" label="活动时间" input-align="right" />
			<van-calendar v-model="showDate" type="range" @confirm="onConfirm" />
			<van-field v-model="area" input-align="right" label="活动地点" placeholder="请输入" maxlength="50" />
			<van-field v-model="number" type="number" input-align="right" label="活动人数" placeholder="0" maxlength="5" />
			<div class="programme-container">
				<div class="title">
					活动方案
				</div>
				<van-uploader v-model="fileList" multiple :after-read="afterRead" />
			</div>
		</van-cell-group>

		<div id="btn-container">
			<van-button
				id="btn-submit"
				type="info"
				block
				:disabled="
					name.trim() == '' ||
						!isValidPhoneFlag ||
						company.trim() == '' ||
						theme.trim() == '' ||
						time.trim() == '' ||
						area.trim() == '' ||
						number <= 0 ||
						fileList.length <= 0 ||
						isUploading
				"
				>提交</van-button
			>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data() {
		return {
			name: '',
			phone: '',
			startTime: '',
			endTime: '',
			company: '',
			theme: '',
			area: '',
			number: null,
			fileList: [],
			date: '',
			showDate: false,
			uploadImageUrls: [],
			phoneErrorMessage: '',
			isValidPhoneFlag: false,
			isUploading: false,
		}
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId', 'companyId']),
	},
	methods: {
		submit() {
			this.isUploading = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/activities/apply`,
				{
					community_id: this.communityId,
					companyName: this.companyName,
					name: this.name,
					address: this.area,
					start_time: this.startTime,
					end_time: this.endTime,
					theme: this.theme,
					number: this.number,
					uploadImageUrls: '',
				},
				(res) => {
					if (res.msg == '成功') {
						this.$toast.success('提交成功')
						let timer = setTimeout(() => {
							this.$router.go(-1)
							clearTimeout(timer)
						}, 600)
					}
					this.isUploading = false
				},
				(err) => {
					console.log(err)
					this.isUploading = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
		//手机号码校验
		isValidPhone() {
			var numReg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!numReg.test(this.phone)) {
				this.phoneErrorMessage = '非法手机号'
				this.isValidPhoneFlag = false
			} else {
				this.phoneErrorMessage = ''
				this.isValidPhoneFlag = true
			}
		},
		//附件上传
		afterRead(file) {
			var formData = new FormData()
			formData.append('file', file.file)
			this.isUploading = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/storages/upload`,
				formData,
				(res) => {
					this.uploadImageUrls.push(res.data)
					this.$toast('上传成功')
					this.isUploading = false
				},
				(e) => {
					console.log('上传失败', e)
					this.isUploading = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'multipart/form-data',
					},
				}
			)
		},
		formatDate(date) {
			return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
		},
		onConfirm(date) {
			const [startTime, endTime] = date
			this.showDate = false
			this.startTime = startTime
			this.endTime = endTime
			this.date = `${this.formatDate(startTime)} - ${this.formatDate(endTime)}`
		},
	},
}
</script>

<style>
#app {
	background-color: #f6f6f6;
}

#activitie-applying {
	padding-bottom: 2.125rem;
	padding-top: 1rem;
	background-color: #f6f6f6;
}

#activitie-container {
	margin-top: 0.75rem;
}

.van-field {
	color: #272727;
	font-size: 1rem;
}

.programme-container {
	font-size: 1.25rem;
	font-weight: bold;
	padding: 0 1rem 0 1rem;
	margin-top: 2.125rem;
}

.van-uploader {
	margin-top: 1.5rem;
	margin-bottom: 4.90625rem;
}

#btn-container {
	margin-top: 3.3125rem;
	width: 100%;
	text-align: center;
}

#btn-submit {
	width: 91.47%;
	font-size: 1.125rem;
	height: 2.75rem;
	padding: 0;
	margin: 0 auto;
}
</style>
